import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebhookDeliveryDetailStateType } from 'src/types/webhookDeliveryDetail';

const initialState: WebhookDeliveryDetailStateType = {
    data: null,
    loading: false,
    error: false,
};

export const webhookDeliveryDetailSlice = createSlice({
    name: 'webhookDeliveryDetail',
    initialState,
    reducers: {
        getWebhookDeliveryDetailFetch: (state, _action: PayloadAction<string>) => {
            state.loading = true;
            state.error = false;
        },
        getWebhookDeliveryDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getWebhookDeliveryDetailFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearWebhookDeliveryDetail: () => initialState,
    },
});

export const {
    getWebhookDeliveryDetailFetch,
    getWebhookDeliveryDetailFetchSuccess,
    getWebhookDeliveryDetailFetchFailure,
    clearWebhookDeliveryDetail,
} = webhookDeliveryDetailSlice.actions;

export default webhookDeliveryDetailSlice.reducer;
